"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _form = require("@widergy/web-utils/lib/form");

var _UTLabel = _interopRequireDefault(require("../UTLabel"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _ImageRadioCard = _interopRequireDefault(require("./components/ImageRadioCard"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var UTImageRadio = function UTImageRadio(_ref) {
  var _ref$input = _ref.input,
      value = _ref$input.value,
      onChange = _ref$input.onChange,
      meta = _ref.meta,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      classes = _ref.classes;

  var newOptions = _toConsumableArray(options);

  var handleOrderedOptions = function handleOrderedOptions(a, b) {
    return a.order - b.order;
  };

  var renderOptions = function renderOptions(item) {
    return _react["default"].createElement(_ImageRadioCard["default"], {
      option: item,
      isSelected: value === item.value,
      onChange: onChange,
      classes: classes
    });
  };

  return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement("div", {
    className: _stylesModule["default"].container
  }, newOptions.sort(handleOrderedOptions).map(renderOptions)), (0, _form.shouldShowErrors)(meta) && _react["default"].createElement(_UTLabel["default"], {
    className: _stylesModule["default"].error,
    error: true
  }, meta.error));
};

UTImageRadio.propTypes = {
  input: _propTypes.string,
  meta: _propTypes.string,
  options: _propTypes.string,
  classes: _propTypes.any // eslint-disable-line react/forbid-prop-types

};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)((0, _react.memo)(UTImageRadio));

exports["default"] = _default;